import { MakeCall } from './createMakeCall';
import { SCARequiresNextAction } from './types/SCARequiresNextAction';
import { APIV2_URL } from './constants';

export default (makeCall: MakeCall) => () =>
  makeCall<SCARequiresNextAction>(
    'POST',
    `${APIV2_URL}/user/me/init-sca-payment-method`,
    {
      headers: {
        'X-HA-Features': 'enable-cc-sca',
      },
    },
  );
